import { createSlice } from "@reduxjs/toolkit";
import { LoadingStatus } from "../sessions/models/LoadingStatus";
import { RootState } from "../../app/store";
import { submitFeedback } from "./slice-extensions/feedback-slice-extension";

interface FeedbackState {
  submitStatus: LoadingStatus;
}

const initialState: FeedbackState = {
  submitStatus: LoadingStatus.Idle,
};

const feedbackSlice = createSlice({
  name: "feedback",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(submitFeedback.pending, (state) => {
        state.submitStatus = LoadingStatus.Loading;
      })
      .addCase(submitFeedback.fulfilled, (state) => {
        state.submitStatus = LoadingStatus.Idle;
      })
      .addCase(submitFeedback.rejected, (state) => {
        state.submitStatus = LoadingStatus.Failed;
      });
  },
});

export const selectFeedbackSubmitStatus = (state: RootState) => state.feedback.submitStatus;

export default feedbackSlice.reducer;
